import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL;

export default function MFDChangePassword() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPw, setShowCurrentPw] = useState(false);
  const [showNewPw, setShowNewPw] = useState(false);
  const [showConfirmPw, setShowConfirmPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { token, user, updateUser } = useAuth();
  const navigate = useNavigate();
  const forced = !!user?.must_change_password;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 8) { setError('New password must be at least 8 characters.'); return; }
    if (newPassword !== confirmPassword) { setError('New passwords do not match.'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/change-password`,
        forced ? { new_password: newPassword } : { current_password: currentPassword, new_password: newPassword },
        { headers: { Authorization: `Bearer ${token}` } });
      updateUser({ must_change_password: false });
      navigate('/mfd');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.logo}>FIP</div>
          <h1 style={styles.title}>{forced ? 'Set a New Password' : 'Change Password'}</h1>
          <p style={styles.subtitle}>
            {forced
              ? 'For security, you must set a new password before continuing.'
              : 'Enter your current and new password.'}
          </p>
        </div>
        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}
          {!forced && (
            <div style={styles.field}>
              <label style={styles.label}>Current Password</label>
              <div style={styles.pwWrap}>
                <input type={showCurrentPw ? 'text' : 'password'} value={currentPassword} onChange={e => setCurrentPassword(e.target.value)}
                  style={{ ...styles.input, flex: 1 }} placeholder="Temporary / current password" required />
                <button type="button" style={styles.pwToggle} onClick={() => setShowCurrentPw(!showCurrentPw)}>{showCurrentPw ? '🙈' : '👁'}</button>
              </div>
            </div>
          )}
          <div style={styles.field}>
            <label style={styles.label}>New Password</label>
            <div style={styles.pwWrap}>
              <input type={showNewPw ? 'text' : 'password'} value={newPassword} onChange={e => setNewPassword(e.target.value)}
                style={{ ...styles.input, flex: 1 }} placeholder="At least 8 characters" required />
              <button type="button" style={styles.pwToggle} onClick={() => setShowNewPw(!showNewPw)}>{showNewPw ? '🙈' : '👁'}</button>
            </div>
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Confirm New Password</label>
            <div style={styles.pwWrap}>
              <input type={showConfirmPw ? 'text' : 'password'} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
                style={{ ...styles.input, flex: 1 }} placeholder="Re-enter new password" required />
              <button type="button" style={styles.pwToggle} onClick={() => setShowConfirmPw(!showConfirmPw)}>{showConfirmPw ? '🙈' : '👁'}</button>
            </div>
          </div>
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Updating...' : 'Update Password'}
          </button>
        </form>
        <p style={styles.footer}>Fund Intelligence Platform © 2026</p>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: 'linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Segoe UI', sans-serif" },
  card: { background: '#fff', borderRadius: '12px', padding: '48px 40px', width: '100%', maxWidth: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  header: { textAlign: 'center', marginBottom: '32px' },
  logo: { background: '#1565C0', color: '#fff', width: '56px', height: '56px', borderRadius: '12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', marginBottom: '16px' },
  title: { fontSize: '20px', color: '#1565C0', margin: '0 0 8px', fontWeight: '700' },
  subtitle: { color: '#666', margin: 0, fontSize: '14px' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#333' },
  input: { padding: '12px 14px', border: '1.5px solid #ddd', borderRadius: '8px', fontSize: '14px', outline: 'none' },
  pwWrap: { display: 'flex', alignItems: 'center', gap: '8px' },
  pwToggle: { background: 'none', border: '1.5px solid #ddd', borderRadius: '8px', padding: '8px 10px', cursor: 'pointer', fontSize: '16px' },
  button: { background: '#1565C0', color: '#fff', border: 'none', borderRadius: '8px', padding: '14px', fontSize: '15px', fontWeight: '600', cursor: 'pointer', marginTop: '8px' },
  error: { background: '#ffebee', color: '#CC0000', padding: '12px', borderRadius: '8px', fontSize: '13px', border: '1px solid #ffcdd2' },
  footer: { textAlign: 'center', color: '#aaa', fontSize: '12px', marginTop: '24px' },
};
